var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4545 2H2.54545C2.24421 2 2 2.24421 2 2.54545V13.4545C2 13.7558 2.24421 14 2.54545 14H13.4545C13.7558 14 14 13.7558 14 13.4545V2.54545C14 2.24421 13.7558 2 13.4545 2Z",
    stroke: "#1D253C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5C6.05228 6.5 6.5 6.05228 6.5 5.5C6.5 4.94771 6.05228 4.5 5.5 4.5C4.94772 4.5 4.5 4.94772 4.5 5.5C4.5 6.05228 4.94771 6.5 5.5 6.5Z",
    stroke: "#1D253C",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.94538L11.113 7.15444C11.0107 7.05556 10.8719 7 10.7273 7C10.5826 7 10.4439 7.05556 10.3416 7.15444L7.29479 10.0998C7.1925 10.1987 7.05376 10.2543 6.90909 10.2543C6.76443 10.2543 6.62569 10.1987 6.5234 10.0998L5.11297 8.73635C5.01068 8.63746 4.87194 8.58191 4.72727 8.58191C4.58261 8.58191 4.44387 8.63746 4.34158 8.73635L2 11",
    stroke: "#1D253C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.76357320900313df6048ad9201a9cba2.svg";
export { ForwardRef as ReactComponent };